
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getSetAlwaysOnDtoFormGroup() {
return new FormGroup({
    alwaysOn: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
})
;
}
      